import { apiFetch } from '../client';
import type { ListItem } from '../SharePointListClient';

/**
 * EF Items — Estado Financiero top-level classification (AR-only today).
 * Lean Supabase-backed CRUD via /api/estado-financiero/items; shaped into
 * the `ListItem` envelope so it plugs into `SimpleAbmEntity` unchanged.
 */
export type EfItemFields = {
  Nombre?: string | null;
  Status?: 'Activo' | 'Inactivo' | string | null;
};
export type EfItemItem = ListItem<EfItemFields>;

type EfItemRow = {
  id: number;
  nombre: string;
  status: string;
  created_at: string;
  updated_at: string;
};

const toItem = (r: EfItemRow): EfItemItem => ({
  id: String(r.id),
  createdDateTime: r.created_at,
  lastModifiedDateTime: r.updated_at,
  fields: { Nombre: r.nombre, Status: r.status },
});

export async function listAllEfItems(): Promise<EfItemItem[]> {
  const rows = await apiFetch<EfItemRow[]>('/api/estado-financiero/items');
  return rows.map(toItem);
}

export async function listActiveEfItems(): Promise<EfItemItem[]> {
  return (await listAllEfItems()).filter((i) => i.fields.Status === 'Activo');
}

export async function createEfItem(nombre: string): Promise<EfItemItem> {
  return toItem(
    await apiFetch<EfItemRow>('/api/estado-financiero/items', {
      method: 'POST',
      body: { nombre },
    }),
  );
}

export async function updateEfItem(id: string, nombre: string): Promise<EfItemItem> {
  return toItem(
    await apiFetch<EfItemRow>(`/api/estado-financiero/items/${id}`, {
      method: 'PATCH',
      body: { nombre },
    }),
  );
}

export async function softDeleteEfItem(id: string): Promise<EfItemItem> {
  return toItem(
    await apiFetch<EfItemRow>(`/api/estado-financiero/items/${id}`, {
      method: 'PATCH',
      body: { status: 'Inactivo' },
    }),
  );
}
